/**
 * RegionalTeachersResupply — "Resupply Coverage" card: upcoming
 * resupply runs and their drivers. Inventory-dependent, so the whole
 * body sits behind <MockedOverlay> (BON-144) as an em-dash skeleton.
 */
import { MockedOverlay } from '../primitives';

const EM_DASH = '—';

const SKELETON_KEYS = ['a', 'b', 'c', 'd', 'e'] as const;

function SkeletonRow({ flagged }: { flagged: boolean }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '5px 0' }}>
      <span style={{ width: 80, fontSize: 11, fontWeight: 600, color: 'var(--nb-subtle)' }}>
        {EM_DASH}
      </span>
      <span style={{ flex: 1, fontSize: 11, color: 'var(--nb-subtle)' }}>{EM_DASH}</span>
      <span
        style={{
          fontSize: 11,
          fontWeight: flagged ? 700 : 500,
          color: flagged ? 'var(--nb-warn)' : 'var(--nb-subtle)',
          minWidth: 80,
          textAlign: 'right',
        }}
      >
        {flagged ? '⚠ Needs driver' : EM_DASH}
      </span>
    </div>
  );
}

export function RegionalTeachersResupply() {
  return (
    <section className="nb-card" style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="nb-card-hd">
        <h3 className="nb-display" style={{ fontSize: 13, letterSpacing: '0.04em', margin: 0 }}>
          Resupply Coverage
        </h3>
        <span className="nb-eyebrow">drivers · 5 weeks</span>
      </div>
      <MockedOverlay reason="Resupply scheduling needs the inventory module. Tracked in BON-144.">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {SKELETON_KEYS.map((k, i) => (
            <SkeletonRow key={k} flagged={i === 1} />
          ))}
        </div>
      </MockedOverlay>
    </section>
  );
}
